/**
 * Các options khi chọn tại combobox Tổng hợp của form tham số báo cáo
 */
export default {
  AllProvince: 2,
  Province: 1,
  District: 0,
};
